import React from 'react';
import {
  Container,
  TextField,
  Button,
  Typography,
  Snackbar,
  Alert
} from '@mui/material';
import ReCAPTCHA from "react-google-recaptcha";

const LoginForm = ({
                     email,
                     password,
                     recaptchaToken,
                     onEmailChange,
                     onPasswordChange,
                     onRecaptchaChange,
                     onLogin,
                     error,
                     openSnackbar,
                     onCloseSnackbar
                   }) => (
  <Container maxWidth="sm" sx={{
    marginTop: "4rem",
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center'
  }}>
    <Typography variant="h4" gutterBottom>Admin Login</Typography>
    <TextField
      fullWidth
      margin="normal"
      label="Email"
      value={email}
      onChange={onEmailChange}
    />
    <TextField
      fullWidth
      margin="normal"
      type="password"
      label="Password"
      value={password}
      onChange={onPasswordChange}
    />
    <ReCAPTCHA
      sitekey="6Lf3pScrAAAAAOpS_DndCtfs7vA8_W5y5lEOfw79"
      onChange={onRecaptchaChange}
      style={{margin: '16px 0'}}
    />
    <Button
      variant="contained"
      onClick={onLogin}
      fullWidth
      sx={{mt: 2}}
    >
      Login
    </Button>

    {/* Added Snackbar for error messages */}
    <Snackbar
      open={openSnackbar}
      autoHideDuration={6000}
      onClose={onCloseSnackbar}
      anchorOrigin={{vertical: 'top', horizontal: 'center'}}
    >
      <Alert
        severity={error?.includes("success") ? "success" : "error"}
        onClose={onCloseSnackbar}
        sx={{width: '100%'}}
      >
        {error}
      </Alert>
    </Snackbar>
  </Container>
);

export default LoginForm;